import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from "@angular/core";
import { Direction } from "./models/direction";
import { DistributionService } from "./services";
import { PermissionRequiredDirective } from "../shared/authentication/permission-required.directive";

import { RouterLinkComponent } from "../shared/router-link/router-link.component";

@Component({
    templateUrl: './document-config-links.component.html',
    selector: 'ep-document-config-links',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PermissionRequiredDirective, RouterLinkComponent]
})

export class DocumentConfigLinksComponent implements OnChanges {

    constructor(private distributionService: DistributionService) { }

    @Input() distributionDirection: Direction;
    @Input() distributionId: number;
    @Input() documentConfigId: number;

    async ngOnChanges(changes: SimpleChanges) {
        if ((changes.distributionId || changes.distributionDirection) && (this.distributionId && this.distributionDirection)) {
            const distributions = await this.distributionService.getDistributions([this.distributionId]);
            if (distributions.length > 0) {
                const distribution = distributions[0];
                this.documentConfigId = this.distributionDirection === Direction.In ? distribution.DocumentConfigIn.DocumentConfigsId : distribution.DocumentConfigOut.DocumentConfigsId;
            }
        }
    }
}
